import React from "react";
import { graphql } from "gatsby";
import SEO from "../components/SEO";
import {
  PageSection,
  PageSectionArticle,
  PageSectionWrapper,
  TextEditor,
} from "../components/common";
import { toHTML } from "../utils/helpers";

const PrivacyPageTemplate = ({ title, privacyData }) => {
  const { heading, body } = privacyData;
  return (
    <>
      <SEO title={title} />
      <PageSectionWrapper bgColor="var(--creamWhite)">
        <PageSection bgColor="var(--creamWhite)">
          <PageSectionArticle>
            <h1>{heading}</h1>
            <TextEditor
              style={{ maxWidth: "900px" }}
              dangerouslySetInnerHTML={{ __html: toHTML(body) }}
            />
          </PageSectionArticle>
        </PageSection>
      </PageSectionWrapper>
    </>
  );
};

const PrivacyPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;

  return (
    <PrivacyPageTemplate
      title={frontmatter.title}
      privacyData={frontmatter.privacyData}
    />
  );
};

export default PrivacyPage;

export const pageQuery = graphql`
  query PrivacyPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        privacyData {
          heading
          body
        }
      }
    }
  }
`;